import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
// import FileUpload from "../../../features/FileUpload/FileUpload";
import LoadingComponent from '../../layout/LoadingComponent';
import { useStore } from '../../stores/store';
import AssetFileUpload from './AssetFileUpload';

function UploadModal() {
  const [open, setOpen] = React.useState(false);
  const { activityStore, mediaAssetStore, commonStore } = useStore();
  const { selectedActivity: activity, loadingInitial } = activityStore;

  const [
    imageUrl,
    // setimageUrl
  ] = useState<imageData[]>([]);
  // const[test,setTest]=useState<any>()
  const uploadURL = (val: imageData) => {
    // setimageUrl((imageUrl: imageData[])=>[...imageUrl,val])     //upload  image string
    mediaAssetStore.setAssetFile([val]);
  };

  if (loadingInitial || !activity) return <LoadingComponent />;
  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <Icon
          name="add"
          size="tiny"
          style={{ cursor: 'pointer' }}
          // disabled={
          //   dashboardStore.dashboard.selectedUserRoleId.includes('AVIAVDB3')
          //     ? false
          //     : true
          // }
          disabled={commonStore.filterModeZero?.includes('AVLAVT06')}
        />
      }
    >
      <Modal.Header>Upload Files</Modal.Header>
      <Modal.Content image>
        {/* <PhotoUploadWidget /> */}
        {/* <FileUpload activity={activity} /> */}
        <AssetFileUpload uploadURL={uploadURL} setOpen={setOpen} name={'Upload Files'}/>
        {imageUrl?.map((url) => (
          <p key={url.id} style={{ color: 'black' }}>
            <img
              src={url.url.includes('pdf') ? '/assets/documents.jpg' : url.url}
              key={url.id}
              alt="/assets/documents.jpg"
              height="70px"
              width="70px"
            />
            {url.fileName}
          </p>
        ))}
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" onClick={() => setOpen(false)}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default observer(UploadModal);
interface imageData {
  id: string;
  url: string;
  fileName: string;
}
